<template>
    <div class="wx-container wx-container-flex">
        <div class="banner" v-if="detail">{{detail.title}}</div>
        <div style="height: 15px" v-else></div>
        <div class="scroll-container scroll-container-card scroll-container-flex">
            <div class="reply-title" v-if="detail && detail.to_user">
                <div class="reply-title__prefix">发送至：</div>
                <img class="reply-title__avatar" :src="detail.to_user.avatar.src" mode="aspectFill"/>
                <div class="reply-title__username">
                    {{detail.to_user.username}}
                </div>
            </div>
            <div class="separate-line"></div>
            <div class="form-item">
                <div class="form-item__body">
                    <textarea
                    v-model="message"
                    class="form-item__body_input textarea"
                    placeholder="请填写消息内容"
                    style="height: 150px;"
                    maxlength="300"></textarea>
                </div>
            </div>

            <message-album :album="album" :queue="queue"></message-album>

            <!-- <input
            class="editor-input"
            type="file" ref="album"
            @change="select"
            id="photo"
            accept="image/jpeg, image/gif, image/jpg, image/png" multiple/>

            <div class="reply-menu" v-if="album.length + queue.length < 3">
                <div class="reply-menu__item" @click="choose">
                    <img class="reply-menu__item_icon" src="@/assets/icons/camera-retro-sharp-light.svg"/>
                    <div>添加图片</div>
                </div>
            </div> -->
        </div>

        <div class="footer-operation">
            <div class="operation-container">
                <div class="operation-container__btn" @click="confirm">
                    发 送
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MessageAlbum from '@/components/Message/album'
    import token from '@/interface/utils/token'
    import uploader from '@/mixins/uploader'
    import { sendMessage } from '@/interface/modules/message.api'
    const weui = window.weui

    export default {
        mixins: [uploader],
        components: {
            MessageAlbum
        },
        data  () {
            return {
                album: [],
                message: '',
                detail: null
            }
        },
        activated () {
            this.detail = token.getToken('dialog')
        },
        methods: {
            choose () {
                const input = document.querySelector('#photo')
                input.click()
            },
            send (next) {
                const that = this
                const info = {send_param: this.detail.send_param}
                if (this.album && this.album.length > 0) {
                    info.file_ids = this.album.map(file => file.id).join(',')
                }
                if (this.message == '') {
                    weui.alert('发送内容不可为空')
                } else if (this.queue && this.queue.length > 0) {
                    weui.alert('尚有照片上传中，请稍后...')
                } else {
                    const loading = weui.loading('发送中...')
                    sendMessage({
                        data: {...info, message: this.message},
                        success: res => {
                            loading.hide()
                            weui.toast('发送成功', {
                                duration: 1000,
                                callback: () => {
                                    if (next) next()
                                    else setTimeout(() => {
                                        that.$router.push({name: 'messageDetail', params: {id: res.id}})
                                    }, 1000)
                                }
                            })
                        },
                        fail () {
                            loading.hide()
                        }
                    })
                }
            },
            confirm () {
                this.send()
            }
        }
    }
</script>

<style lang="less" scoped>
    .editor-input {
        width: 0;
        height: 0;
        opacity: 0;
    }
    .reply-title {
        display: flex;
        align-items: center;
        background-color: #f5f7fa;
        padding: 15px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        font-size: 10pt;
        .reply-title__prefix {
            color: #999;
            margin-right: 15px;
        }
        .reply-title__avatar {
            width: 32px;
            height: 32px;
            border-radius: 100%;
            margin-right: 10px;
        }
        .reply-title__username {
            flex: 1;
        }
    }

    .reply-menu {
        .reply-menu__item {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #eee;
            padding: 10px 0;
            &.disabled {
                opacity: .5;
            }
            .reply-menu__item_icon {
                width: 20px;
                height: 20px;
                margin-right: 20px;
                opacity: .75;
            }
        }
    }
</style>

